import React, { Component } from 'react'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import * as actions from '../actions'
import { postVipForm } from '../selectors'
import AddVipForm from '../components/AddVipForm'
import ConvertVipForm from '../components/ConvertVipForm'
import NotFound from './NotFound'

class VipPage extends Component {
  props: {
    isPosting: boolean,
    separate: boolean,
    postError: string,
    postNewVip: Function,
    vipData: {
      pubId: number,
      userId: string,
      siteConfigId: number
    }
  }

  handleNewVipSubmit = (values) => {
    this.props.postNewVip(values)
  }

  handleConvertVipSubmit = (values) => {
    this.props.postVipConvert(values);
  }

  render() {
    const { isPosting, separate, postError, vipData } = this.props
    const { form } = this.props.params;
    if (form === 'convert') {
      return (
        <ConvertVipForm
          onSubmit={this.handleConvertVipSubmit}
          isPosting={isPosting}
          separate={separate}
          postError={postError}
          vipData={vipData}
        />
      )
    }
    else if (form === 'add') {
      return (
        <AddVipForm
          onSubmit={this.handleNewVipSubmit}
          isPosting={isPosting}
          separate={separate}
          postError={postError}
          vipData={vipData}
        />
      )
    }
    return <NotFound />
  }
}

// get form values
const selector = formValueSelector('addVip')

const mapStateToProps = state => ({
  separate: selector(state, 'separateUsers'),
  ...postVipForm(state)
})

export default connect(mapStateToProps, actions)(VipPage)



// WEBPACK FOOTER //
// ./src/pages/VipPage.js